export default {
  isMate: state => (state.is_mate !== 0),
  mateType: state => state.is_mate,
  isLoggedIn: state => !!state.token,
  isSubscriber: state => state.subscription !== null && state.subscription.status === 1,
  subscriptionDefaulted: state => state.subscription !== null
    && [6, 7, 8].includes(state.subscription.status),
  subscriptionCarrierFeePending: state => state.subscription !== null
    && state.subscription.status === 9,
}
